import getCookie from "@vfuk/core-helpers/dist/getCookie";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const isLoggedIn = getCookie("Token") || false;

  if (isLoggedIn) {
    return <Outlet />;
  }

  return <Navigate to="/login?sessionExpired" />;
};

export default ProtectedRoute;
